import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/services/user.service';
@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

  public mobile='';
  
  public errorOccurred=false;
  public errorOccurredMessage='';
   public sendSuccess=false;
  public sendSuccessMessage=''; 
  successMobile: boolean = false;
  errorMobileMessage="";
  constructor(private user: UserService) { }

  ngOnInit(): void {
  }

  
  userForgetPassword() {
   
  
    this.errorOccurred=false;
    this.errorOccurredMessage="";
    
    if (this.mobile == '') {
      this.successMobile = true;
      this.errorOccurred=true;
      this.errorOccurredMessage="Enter Valid Mobile";
      return;
    }

  

    if (this.successMobile === true ) {
      return;
    } else {
      let body={
        "mobile":this.mobile,
      }
      // console.log("body befor send to server",body);
      this.user.userForgetPassword(body).subscribe((data) => {
        if (data.success== true) {
       
          this.sendSuccess=false;
          this.errorOccurredMessage='';
          if (data.success == true) {
            this.sendSuccess=true;
            this.sendSuccessMessage=data.message;
          }

          
        } else {
          this.errorOccurred=false;
          this.errorOccurredMessage='';
          if (data.success == false) {
            this.errorOccurred=true;
            this.errorOccurredMessage=data.message;
          }
          return;
        }
      });
    }
  }

}
